import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CustomToastService {
  private activeMessages: {
    severity: string;
    summary: string;
    detail?: string;
  }[] = [];

  constructor(private messageService: MessageService) {}

  addUnique(message: {
    severity: string;
    summary: string;
    detail?: string;
    life?: number;
  }) {
    const isDuplicate = this.activeMessages.some(
      (m) =>
        m.severity === message.severity &&
        m.summary === message.summary &&
        m.detail === message.detail
    );
    if (!isDuplicate) {
      this.activeMessages.push({
        severity: message.severity,
        summary: message.summary,
        detail: message.detail,
      });
      this.messageService.add(message);

      setTimeout(() => {
        this.activeMessages = this.activeMessages.filter(
          (m) =>
            !(
              m.severity === message.severity &&
              m.summary === message.summary &&
              m.detail === message.detail
            )
        );
      }, message.life ?? 3000);
    }
  }

  clear() {
    this.messageService.clear();
    this.activeMessages = [];
  }

  removeMessage(message: {
    severity: string;
    summary: string;
    detail?: string;
  }) {
    this.activeMessages = this.activeMessages.filter(
      (m) =>
        !(
          m.severity === message.severity &&
          m.summary === message.summary &&
          m.detail === message.detail
        )
    );
  }
}
